export const CLIENT_ACCOUNT_FULL_ROUTE = 'accounts/:id/:cbTabRouteId';
